import React from 'react';
import Footer from './Footer';

function Terms() {
  return (
    <div className="bg-homeColor min-w-[280px] px-6 py-10 flex flex-col items-center text-white">
      <div className="w-[80%]">
      <h2 className="mt-20 font-bold text-center text-2xl lg:text-5xl mb-8">Terms and Conditions</h2>

      <p className="mb-6"><strong>Effective Date:</strong>17-05-2025</p>

      <p className="mb-4">
        Welcome to <a href="https://lotez.in" className="underline text-blue-300" target="_blank" rel="noopener noreferrer">https://lotez.in</a> ("Site"), owned and operated by Lotez Technologies (OPC) Private Limited ("Company", "we", "our").
      </p>

      <p className="mb-6">
        By accessing or using our Site, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use our Site.
      </p>

      <ol className="list-decimal ml-6 space-y-4">
        <li>
          <strong>Use of the Site:</strong> You agree to use our website for lawful purposes only. You must not use it in a way that may cause damage or impair the availability of access to the Site.
        </li>

        <li>
          <strong>Intellectual Property:</strong> All content, trademarks, logos, and intellectual property on the Site are owned by or licensed to Lotez Technologies (OPC) Private Limited. Unauthorized use is prohibited.
        </li>

        <li>
          <strong>User Submissions:</strong> Any content you submit to us (e.g., through contact forms) is considered non-confidential unless otherwise agreed.
        </li>

        <li>
          <strong>Limitation of Liability:</strong> We are not liable for any direct, indirect, incidental, or consequential damages resulting from your use of the Site.
        </li>

        <li>
          <strong>Third-Party Links:</strong> Our Site may contain links to third-party websites. We do not control or endorse them and are not responsible for their content or terms.
        </li>

        <li>
          <strong>Termination:</strong> We reserve the right to suspend or terminate access to the Site at our discretion, without notice.
        </li>

        <li>
          <strong>Governing Law:</strong> These Terms shall be governed and interpreted under the laws of India. Any disputes shall be resolved in the courts of Hyderabad, Telangana, India.
        </li>

        <li>
          <strong>Changes to the Terms:</strong> We may update these Terms from time to time. The latest version will always be posted on this page.
        </li>

        <li>
          <strong>Contact Us:</strong> For questions about these Terms, please contact:
          <div className=" mt-2">
            Lotez Technologies (OPC) Private Limited<br />
            Email: <a href="mailto:hello@lotez.in" className="underline text-blue-300">hello@lotez.in</a><br />
            Website: <a href="https://lotez.in" className="underline text-blue-300" target="_blank" rel="noopener noreferrer">https://lotez.in</a>
          </div>
        </li>
      </ol>
    </div>
	<Footer />
    </div>
  );
}


export default Terms
